import { CacheContext } from 'contexts';
import { useCallback, useState } from 'react';

const CacheProvider = ({ children }) => {
  const [cache, setCache] = useState({});

  const getData = useCallback((key) => cache[key], [cache]);

  const setData = useCallback((key, data) => {
    setCache((prev) => ({ ...prev, [key]: data }));
  }, []);

  const getKey = useCallback((name, filters) => {
    const filtersKey = filters ? JSON.stringify(filters) : undefined;
    return filtersKey ? `${name}_${filtersKey}` : name;
  }, []);

  return (
    <CacheContext.Provider value={{ getKey, getData, setData }}>
      {children}
    </CacheContext.Provider>
  );
};

export default CacheProvider;
